import { base32tohex, generateRandomBase32 } from '../../../../../../util/base32-helper';
import { generatePassword } from '../../../../../../util/sp-util';

export class Controller {

    /** @ngInject */
    constructor($state,Alert, SharedAccountsService) {
        this.Alert = Alert;
        this.$state=$state;
        this.SharedAccountsService = SharedAccountsService;
    }

    $onInit() {
        this.tooltipTemplate = require('../../secret-tooltip.html');
        this.simulatedHardtokenTemplate = require('../../simulated-hardtoken-tooltip.html');
        if(this.copyAccount != null) {
            this.account = this.copyAccount;
            this.resetHexSecret();
            this.searchItem = this.account.publicService.serviceName !== 'Other' ? this.account.publicService.serviceName : 'Custom';
        } else {
            this.account = {
                algorithm: 'SHA1',
                digits: 6,
                showOtpEnabled: true,
                showPasswordEnabled: true,
                showNoteEnabled: false,
            };
        }
        this.publicServicesWithSsoAnd2FA$.get().then(items => this.publicServices=items);
    }

    save() {
        this.isSaving = true;
        this.SharedAccountsService.createCompanyServiceAccounts(
            {
                companyId: this.companyId,
                publicServiceId: this.account.publicService.id,
            },
            {
                username: this.account.username,
                password: this.account.password,
                serviceLoginUrl: this.account.serviceLoginUrl,
                enabled2fa: true,
                showOtpEnabled: this.account.showOtpEnabled,
                showPasswordEnabled: this.account.showPasswordEnabled,
                showNoteEnabled: this.account.showNoteEnabled,
                note: this.account.note,
                customServiceName: this.account.customServiceName,
                publicServiceKey: generatePublicServiceKey(
                    this.account.publicService.serviceName,
                    this.account.username,
                    this.account.secret,
                    this.account.digits,
                    this.account.algorithm
                )
            }
        )
            .$promise
            .then(account => {
                this.Alert('success', 'company.sharing-center.add.added');
                this.$state.go('company.sharing-center.shared-authenticators.manage.edit', {sharedAccountId: account.id}, {reload: 'company.sharing-center.shared-authenticators'});
            })
            .finally(() => this.isSaving = false)
    }

    saveDisabled(form) {
        return this.isSaving || form.$invalid || !this.account.publicService;
    }

    selectCustom() {
        this.searchItem = 'Custom';
        this.account.publicService = this.publicServices.find(i => i.slug === "other");
    }

    createSecret() {
        this.isSaving = true;
        this.showSecret = true;
        this.account.secret = generateRandomBase32(32);
        this.resetHexSecret();
        this.isSaving = false;
    }

    resetHexSecret() {
        this.hexSecret = this.convertHex(this.account.secret);
    }

    convertHex(value) {
        if (value == null || value.length == 0)
            return value;
        return base32tohex(value);
    }

    generatePassword() {
        this.account.password = generatePassword(16);
    }
}

function generatePublicServiceKey(issuer, username, secretKey, digits, algorithm) {
    const secret = secretKey.replace(/\s/g, '');
    return `otpauth://totp/${issuer}:${username}?secret=${secret}&issuer=${issuer}&digits=${digits}&algorithm=${algorithm}`;
}



// WEBPACK FOOTER //
// ./src/portal/states/company/sharing-center/shared-authenticators/add/add-shared-authenticator.controller.js